var state = {
  cognitoInfo: {},
  loggedIn: false,
  userId: null,
  userRole: null
}

function setLoggedIn (newValue) {
  state.loggedIn = newValue
}

function setCognitoInfo (newValue) {
  state.cognitoInfo = newValue
  state.userRole = state.cognitoInfo['custom:role']
  state.userId = state.cognitoInfo['username']
}

export default {
  state,
  setLoggedIn,
  setCognitoInfo
}
